<template>
    <div>
        <div class=" flex items-center justify-between px-3">
            <span>Shipping Information</span>
            <span class=" cursor-pointer flex items-center gap-2" @click="collapse = !collapse">Collapse <img
                    src="@/assets/images/arrow-up.svg" :class="[collapse && 'rotate-180']"
                    class=" transition-all duration-200" /></span>
        </div>
        <div v-if="!collapse">
            <div class="box_wrapper ">
                <div class="border-r border-gray-300">
                    <span class=" flex w-full items-center text-gray-500 text-sm gap-2 mb-1">
                        <span class=" inline-flex justify-center items-center w-7 h-7 rounded-full bg-gray-100">
                            <img src="../svgs/to.svg" class="w-[60%]" />
                        </span>
                        FROM
                    </span>
                    <b class=" text-lg font-[500]">{{ shippingTimeline?.senderInformation?.name || "" }}</b>
                    <span class=" text-primary-yellow w-full flex items-center my-2 gap-1"> <img src="../svgs/call.svg"
                            class="w-[20px]" />{{
                                shippingTimeline?.senderInformation?.phone
                                || "" }}</span>
                    <p class=" max-w-[200px] text-gray-400 bg-red">
                        {{ shippingTimeline?.senderInformation?.address || "" }}
                    </p>
                </div>
                <div>
                    <span class=" flex w-full items-center text-gray-500 text-sm gap-2 mb-1">
                        <span class=" inline-flex justify-center items-center w-7 h-7 rounded-full bg-gray-100">
                            <img src="../svgs/from.svg" class="w-[50%]" />
                        </span>
                        TO
                    </span>
                    <b class=" text-lg font-[500]">{{ shippingTimeline?.recipientInformation?.name || "" }}</b>
                    <span class=" text-primary-yellow w-full flex items-center my-2 gap-1"> <img src="../svgs/call.svg"
                            class="w-[20px]" />{{
                                shippingTimeline?.recipientInformation?.phone
                                || "" }}</span>
                    <p class=" max-w-[200px] text-gray-400 bg-red">
                        {{ shippingTimeline?.recipientInformation?.address || "" }}
                    </p>
                </div>
            </div>

            <div class=" flex flex-wrap px-3 py-4">
                <div class="trans_item">
                    <b>ORDER CHANNEL</b>
                    <p class=" text-gray-400 mt-1">{{ shippingTimeline?.orderInformation?.orderChannel }}</p>
                </div>
                <div class="trans_item">
                    <b>ORDER #</b>
                    <p class=" text-gray-400 mt-1">{{ shippingTimeline?.orderInformation?.orderNumber }}</p>
                </div>
                <div class="trans_item">
                    <b>PAYMENT STATUS</b>
                    <p>
                        <span>
                            <button
                                :title="shippingTimeline?.paymentInformation?.transaction?.paymentStatus.replace(/_/g, ' ')"
                                :class="['order_status']"
                                :style="{ ...statusColors(shippingTimeline?.paymentInformation?.transaction?.paymentStatus) }">{{
                                    shippingTimeline?.paymentInformation?.transaction?.paymentStatus }}</button>
                        </span>
                    </p>
                </div>
                <div class="trans_item">
                    <b>INSURED VALUE</b>
                    <p class=" text-gray-400 mt-1">₦{{ formatAmount(shippingTimeline?.orderInformation?.insuredValue) }}
                    </p>
                </div>
                <div class="trans_item">
                    <b>HANDLING COST</b>
                    <p class=" text-gray-400 mt-1">₦{{
                        shippingTimeline?.paymentInformation?.transaction?.breakDown?.handlingCharges }}</p>
                </div>
                <div class="trans_item">
                    <b>SHIPPING COST</b>
                    <p class=" text-gray-400 mt-1">₦{{ formatAmount(shippingTimeline?.paymentInformation?.shippingCost)
                    }}
                    </p>
                </div>
                <div class="trans_item">
                    <b>TOTAL</b>
                    <p class=" text-gray-400 mt-1">₦{{
                        formatAmount(shippingTimeline?.paymentInformation?.transaction?.breakDown?.totalCost) }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            collapse: false
        }
    },
    props: {
        shippingTimeline: {}
    },
    methods: {
        formatAmount(number) {
            return number ? number.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 0;
        },
        statusColors(status) {
            const opac = "25";
            switch (status) {
                case "paid":
                    return { color: "#09B78A", backgroundColor: "#09B78A" + opac };
                case "pending":
                    return { color: "#FFA600", backgroundColor: "#FCC21040" };
            }
        },
    },

}
</script>

<style lang="scss" scoped>
.box_wrapper {
    @apply border-t border-b border-gray-300 flex flex-wrap mt-3;

    div {
        @apply w-full sm:w-6/12 py-4 px-4
    }
}

.trans_item {
    @apply w-full sm:w-6/12 md:w-4/12 lg:w-3/12 mb-4;

    b {
        @apply font-[600]
    }
}

.order_status {
    @apply text-sm whitespace-nowrap capitalize text-ellipsis overflow-hidden rounded-2xl py-1.5 px-6
}
</style>